<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaCentroCustos"
      option-label="code"
      option-value="id"
      label="Selecione o Centro de Custo"
      label-color="grey-6"
      behavior="menu"
      map-options
      :bg-color="disable ? 'grey-3' : ''"
      :disable="disable"
      use-input
      hide-bottom-space
      :rules="validacao ? [(val) => val || 'Campo Obrigatório'] : []"
      @filter="filtrar"
      :display-value="
        modelValue?.code?.length > props.lengthHidden
          ? `${modelValue?.code.substring(0, props.lengthHidden)}....`
          : modelValue?.code
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="modelValue"> {{ props?.modelValue?.code }} </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
  disable: { type: Boolean },
  validacao: {
    type: Boolean,
    default: false,
  },
  lengthHidden: {
    type: Number,
    default: 9,
  },
});

const listaCentroCustos = ref([]);

const listarCentroCustos = async (val) => {
  listaCentroCustos.value = [];
  try {
    const response = await store.dispatch("compras/getCentrosCustos", {
      vendor_id: store.state.org.unidadeData.id,
      search: val,
      page: 1,
    });

    listaCentroCustos.value = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

const filtrar = async (val, update) => {
  await listarCentroCustos(val);
  update();
};
</script>
